<template>
  <div class="rc-l-detail rc-l-detail--seo">
    <div class="rc-l-detail--top">
      <div
        class="container"
        style="overflow: hidden"
      >
        <div class="row">
          <article class="col-lg-9 rc-main-article">
            <div class="ratio ratio-16x9">
              <template v-if="item.thumbnailUrl">
                <img
                  style="width: 100%; height: 100%"
                  :src="item.thumbnailUrl"
                  alt=""
                  @error="imageUrlAlt"
                >
              </template>
              <template v-else>
                <div
                  class="rc-skeleton rc-skeleton-img rc-skeleton-animate-fade"
                />
              </template>
            </div>

            <div class="rc-media-desc">
              <header>
                <h1 class="rc-title mb-2">
                  {{ item.name }}
                </h1>
              </header>

              <div class="row rc-article-body g-0">
                <ul
                  class="nav nav-tabs w-100"
                  role="tablist"
                >
                  <li
                    class="nav-item"
                    role="presentation"
                  >
                    <button
                      id="overviewTab"
                      class="nav-link active"
                      data-bs-toggle="tab"
                      data-bs-target="#overviewTabPanel"
                      type="button"
                      role="tab"
                      aria-controls="overviewTabPanel"
                      aria-selected="true"
                    >
                      {{ $t("common.overview") }}
                    </button>
                  </li>
                  <li
                    class="nav-item"
                    role="presentation"
                  >
                    <button
                      id="metadataTab"
                      class="nav-link"
                      data-bs-toggle="tab"
                      data-bs-target="#metadataTabPanel"
                      type="button"
                      role="tab"
                      aria-controls="metadataTabPanel"
                      aria-selected="false"
                    >
                      {{ $t("catalog.metadata") }}
                    </button>
                  </li>
                </ul>
                <div class="tab-content">
                  <div
                    id="overviewTabPanel"
                    class="tab-pane fade show active"
                    role="tabpanel"
                    aria-labelledby="overviewTab"
                  >
                    <h2 class="visually-hidden">
                      {{ $t("common.overview") }}
                    </h2>
                    <div v-if="item.description">
                      <ul class="list-group list-group-flush rc-list-data">
                        <li
                          v-if="item.description"
                          class="list-group-item"
                        >
                          <div class="row align-items-start">
                            <div class="col-sm-4 col-md-3">
                              <h4>Description</h4>
                            </div>
                            <div class="col-sm-8 col-md-9">
                              <div class="rc-summary">
                                <RcReadMore :contentText="item.description" />
                              </div>
                            </div>
                          </div>
                        </li>
                        <!-- Duration-->
                        <li class="list-group-item">
                          <div class="row align-items-start">
                            <div class="col-sm-4 col-md-3">
                              <h4>{{ $t("common.duration") }}</h4>
                            </div>
                            <div class="col-sm-8 col-md-9">
                              <span
                                aria-hidden="true"
                                :title="
                                  useLocaleDuration(duration, $i18n.locale)
                                "
                              >
                                {{ useShortDuration(duration) }}
                              </span>
                              <span class="visually-hidden">
                                {{ useLocaleDuration(duration, $i18n.locale) }}
                              </span>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    id="metadataTabPanel"
                    class="tab-pane fade"
                    role="tabpanel"
                    aria-labelledby="metadataTab"
                  >
                    <h2 class="visually-hidden">
                      {{ $t("catalog.metadata") }}
                    </h2>
                    <ul class="list-group list-group-flush rc-list-data">
                      <li
                        v-if="item.actors && item.actors.length"
                        class="list-group-item"
                      >
                        <div class="row align-items-start">
                          <div class="col-sm-4 col-md-3">
                            <h4>{{ $t("catalog.team") }}</h4>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <ul>
                              <li
                                v-for="(participant, index) in item.actors"
                                :key="index"
                              >
                                {{ participant.name }}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>

                      <li
                        v-if="item.keywords && item.keywords.length"
                        class="list-group-item"
                      >
                        <div class="row align-items-start">
                          <div class="col-sm-4 col-md-3">
                            <h4>{{ $t("common.categories") }}</h4>
                          </div>
                          <div class="col-sm-8 col-md-9">
                            <ul>
                              <li
                                v-for="(cat, index) in item.keywords"
                                :key="index"
                              >
                                {{ cat }}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </article>

          <!-- Welcome -->
          <aside class="col-lg-3 rc-seo-aside">
            <div class="rc-seo-aside--container">
              <div class="rc-seo-aside--images col-xs-12">
                <img
                  src="/src/assets/img/illustrations/antelope_laptop_cropped.svg"
                  class="rc-seo-antelop d-none d-md-block"
                  alt=""
                >
                <img
                  src="/src/assets/img/illustrations/toucan_blob.svg"
                  class="rc-seo-blob"
                  alt=""
                >
              </div>

              <div class="rc-seo-aside--welcome col-xs-12">
                <h2 class="h3">
                  {{ $t("catalog.seo.title") }}
                </h2>
                <p>
                  {{ $t("catalog.seo.text") }}
                </p>
                <div class="text-center">
                  <router-link
                    :to="toLoginRedirect"
                    class="btn btn-primary btn-lg d-block"
                  >
                    {{ $t("auth.log.in_now") }}
                  </router-link>
                  <button
                    class="btn btn-link"
                    @click="scrollTo('RcSubscription')"
                  >
                    {{ $t("catalog.seo.link_subscription") }}
                  </button>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
    <!-- section : Subscription -->
    <div ref="RcSubscription" />
    <RcInfoSubscription cssClass="rc-bg-wave-yellow-2" />
    <!-- section : Widget verify subscription -->
    <RcVerifySubscription cssClass="rc-verify-subscription rc-section-last" />

    <div class="rc-banner-cta bg-plum">
      <div class="container">
        <div class="row flex-column-reverse flex-md-row">
          <div class="col-md-6 rc-col-max-width">
            <h2 v-html="$t('footer.get_started.banner.title')" />
            <p class="rc-intro--xl">
              {{ $t("footer.get_started.banner.text") }}
            </p>
            <router-link
              :to="toLoginRedirect"
              class="btn btn-primary btn-lg"
            >
              {{
                $t("footer.get_started.banner.cta")
              }}
            </router-link>
          </div>
          <div class="col-md-6 text-end">
            <div class="rc-wrapper-dolphin" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import RcReadMore from '@/libvue/components/readMore/ReadMore.vue';
import RcInfoSubscription from '#/pages/market/components/sections/InfoSubscription.vue';
import RcVerifySubscription from '#/pages/market/components/sections/VerifySubscription.vue';
import fallbackImg from '#/assets/img/fallback.svg';

import { navMixin } from '#/routes/mixins';
import {
  useLocaleDuration,
  useShortDuration
} from '@/libvue/composables/durations';
export default {
  name: 'RcItemSEO',
  components: {
    RcReadMore,
    RcInfoSubscription,
    RcVerifySubscription
  },
  mixins: [navMixin],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  setup() {
    return { useLocaleDuration, useShortDuration };
  },
  computed: {
    duration() {
      return moment.duration('P' + this.item.duration).asSeconds();
    },
    toLoginRedirect() {
      let _toLogin = this.toLogin;

      _toLogin = {
        ...this.toLogin,
        query: { redirect: this.$route.fullPath }
      };

      return _toLogin;
    }
  },
  methods: {
    imageUrlAlt(event) {
      event.target.src = fallbackImg;
    },
    scrollTo(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo({ top });
    }
  }
};
</script>
<style lang="scss"></style>
